module.exports = __webpack_public_path__ + "img/logo_blue_title2x.png?5a6ed1d2d57337da5a0c56eff78dfaa0";